<template>
  <div class="total-item">
    <div class="item to">
      <div class="tenu">
        <div class="text"><span>总人数</span></div>
        <div class="num">
          <span class="big">{{total}}</span>
          <span class="divider">/</span>
          <span class="small">{{nGroup}}个{{sceneLang.public.group}}</span>
        </div>
      </div>
    </div>
    <div class="item no">
      <div class="tenu">
        <div class="text"><span>未用餐</span></div>
        <div class="num">
          <span class="big">{{total > nDined ? total-nDined : 0}}</span><span class="divider">/</span
          ><span class="small">{{100 - dinedRate}}%</span>
        </div>
        <div class="progress">
          <a-progress
            :percent="100 - dinedRate"
            :strokeWidth="3"
            strokeColor="#e4b207"
            :show-info="false"
          />
        </div>
      </div>
    </div>
    <div class="item yes">
      <div class="yi">
        <div class="tenu">
          <div class="text"><span>已用餐</span></div>
          <div class="num">
            <span class="big">{{nDined > total ? total : nDined}}</span><span class="divider">/</span
            ><span class="small">{{dinedRate}}%</span>
          </div>
          <div class="progress">
            <a-progress
              :percent="dinedRate"
              :strokeWidth="3"
              strokeColor="#2fae6f"
              :show-info="false"
            />
          </div>
        </div>
      </div>
      <div class="intake">
        <div class="it">
          <div class="tn">
            <div class="icon">
              <img src="~@/assets/images/icon-school9.png" />
            </div>
            <div class="te">正常摄入</div>
            <div class="nu">{{nDined - nExcess - nInsufficient}}</div>
          </div>
        </div>
        <div class="it">
          <div class="icon">
            <img src="~@/assets/images/icon-school3.png" />
          </div>
          <div class="tn">
            <div class="te">摄入不足</div>
            <div class="nu fprimary">{{nInsufficient}}</div>
          </div>
        </div>
        <div class="it">
          <div class="icon">
            <img src="~@/assets/images/icon-school2.png" />
          </div>
          <div class="tn">
            <div class="te">摄入超量</div>
            <div class="nu fred">{{nExcess}}</div>
          </div>
        </div>
      </div>
      <div class="chart">
        <div id="chartid_total" style="width: 100px;height:100px;"></div>
        <div class="text">健康(<b>{{healthRate}}%</b>)</div>
      </div>
    </div>
  </div>
</template>
<script>
import apis from '@/business/apis'
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  inject: ['eventBus'],
  data () {
    return {
      total: 0,
      nExcess: 0,
      nInsufficient: 0,
      nDined: 0,
      nGroup: 0
    }
  },
  computed: {
    ...mapState('nutrition', ['selectedMeal']),
    ...mapState('school', [
      'currentSchool'
    ]),
    dinedRate () {
      return this.total > 0 ? Math.round(this.nDined / this.total * 100) : 50
    },
    healthRate () {
      return this.nDined > 0 ? Math.round((this.nDined - this.nExcess - this.nInsufficient) / this.nDined * 100) : 50
    }
  },
  methods: {
    async loadData (selectedDate) {
      const query = '?schoolId=' + this.currentSchool._id + '&date=' + selectedDate.unix() + '&meal=' + this.selectedMeal
      const respose = await this.$http.get(apis.nutrition.statistics + query)
      this.total = respose.body.total
      this.nExcess = respose.body.nExcess
      this.nInsufficient = respose.body.nInsufficient
      this.nDined = respose.body.nDined
      this.nGroup = respose.body.nGroup
      this.createChart()
    },
    createChart () {
      const unHealth = this.nExcess + this.nInsufficient
      const health = this.nDined - unHealth
      setTimeout(() => {
        const chart = this.$echarts.init(document.getElementById('chartid_total'))
        const colorList = ['#45c284', '#f1cc5d']
        const option = {
          tooltip: {
            trigger: 'item',
            formatter:
                "<b style='font-size:18px;color:#ffce0a;font-family:DIN Alternate;'>{c}</b><span style='color:#ffce0a;'>人</span>({d}%)"
          },
          series: [
            {
              type: 'pie',
              radius: ['85%', '100%'],
              avoidLabelOverlap: false,
              label: {
                show: false
              },
              labelLine: {
                show: false
              },
              itemStyle: {
                normal: {
                  color: function (params) {
                    return colorList[params.dataIndex]
                  }
                }
              },
              data: [{ value: health }, { value: unHealth }]
            }
          ]
        }
        chart.setOption(option)
      }, 0)
    }
  },
  created () {
    this.eventBus.$on('nutrition-index-date-change', this.loadData)
    this.loadData(moment())
  },
  beforeDestroy () {
    this.eventBus.$off('nutrition-index-date-change', this.loadData)
  }
}
</script>
